import { Controller } from "stimulus"

export default class extends Controller {
  toggleControlPanelOnly(event) {
    const checkbox = event.target
    const userId = checkbox.dataset.userId
    const value = checkbox.checked

    const response = fetch(`/admin/users/${userId}/toggle_control_panel_only`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('[name="csrf-token"]').content
      },
      body: JSON.stringify({
        control_panel_only: value
      })
    })
  }
}
